import { render, staticRenderFns } from "./shareMoney.vue?vue&type=template&id=7f27f52a&scoped=true&"
import script from "./shareMoney.vue?vue&type=script&lang=js&"
export * from "./shareMoney.vue?vue&type=script&lang=js&"
import style0 from "./shareMoney.vue?vue&type=style&index=0&id=7f27f52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f27f52a",
  null
  
)

export default component.exports